import adminApiClient from '../api/adminApiClient'
import { apiError } from '../api/apiError'
import type {
  BranchResponse, BranchCreateRequest, BranchStats, BranchStatus,
  BranchSmsConfig, BranchSmsConfigRequest, SmsSentResponse,
} from '../types'

export async function getBranches(status?: BranchStatus): Promise<BranchResponse[]> {
  const { data } = await adminApiClient.get<BranchResponse[]>('/branches', {
    params: status ? { status } : {},
  })
  return data
}

export async function getBranch(id: string): Promise<BranchResponse> {
  const { data } = await adminApiClient.get<BranchResponse>(`/branches/${id}`)
  return data
}

export async function createBranch(body: BranchCreateRequest): Promise<BranchResponse> {
  const { data } = await adminApiClient.post<BranchResponse>('/branches', body)
  console.log(`[INFO] Branch created — id: ${data.id}, name: ${data.name}`)
  return data
}

export async function updateBranch(id: string, body: BranchCreateRequest): Promise<BranchResponse> {
  const { data } = await adminApiClient.put<BranchResponse>(`/branches/${id}`, body)
  console.log(`[INFO] Branch updated — id: ${id}`)
  return data
}

export async function approveBranch(id: string): Promise<BranchResponse> {
  const { data } = await adminApiClient.post<BranchResponse>(`/branches/${id}/approve`)
  console.log(`[INFO] Branch approved — id: ${id}`)
  return data
}

export async function suspendBranch(id: string, reason: string): Promise<void> {
  await adminApiClient.post(`/branches/${id}/suspend`, { reason })
  console.log(`[INFO] Branch suspended — id: ${id}`)
}

export async function reactivateBranch(id: string): Promise<BranchResponse> {
  const { data } = await adminApiClient.post<BranchResponse>(`/branches/${id}/reactivate`)
  console.log(`[INFO] Branch reactivated — id: ${id}`)
  return data
}

export async function archiveBranch(id: string): Promise<void> {
  await adminApiClient.post(`/branches/${id}/archive`)
  console.log(`[INFO] Branch archived — id: ${id}`)
}

// Логотип: PNG, JPEG или WebP до 1 МБ, отдаётся клиентам по logoUrl
export async function uploadBranchLogo(id: string, file: File): Promise<BranchResponse> {
  const form = new FormData()
  form.append('file', file)
  // клиент по умолчанию шлёт JSON — без явного multipart axios сериализует FormData в JSON
  const { data } = await adminApiClient.post<BranchResponse>(`/branches/${id}/logo`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  console.log(`[INFO] Branch logo uploaded — id: ${id}`)
  return data
}

export async function deleteBranchLogo(id: string): Promise<void> {
  await adminApiClient.delete(`/branches/${id}/logo`)
  console.log(`[INFO] Branch logo deleted — id: ${id}`)
}

export async function getBranchStats(id: string): Promise<BranchStats> {
  const { data } = await adminApiClient.get<BranchStats>(`/branches/${id}/stats`)
  return data
}

// SMS config: 404 SMS_CONFIG_NOT_FOUND означает, что SMS для филиала ещё не настроены
export async function getBranchSmsConfig(id: string): Promise<BranchSmsConfig | null> {
  try {
    const { data } = await adminApiClient.get<BranchSmsConfig>(`/branches/${id}/sms-config`)
    return data
  } catch (err) {
    if (apiError(err).status === 404) return null
    throw err
  }
}

export async function saveBranchSmsConfig(id: string, body: BranchSmsConfigRequest): Promise<BranchSmsConfig> {
  const { data } = await adminApiClient.put<BranchSmsConfig>(`/branches/${id}/sms-config`, body)
  console.log(`[INFO] Branch SMS config saved — id: ${id}`)
  return data
}

export async function deleteBranchSmsConfig(id: string): Promise<void> {
  await adminApiClient.delete(`/branches/${id}/sms-config`)
  console.log(`[INFO] Branch SMS config deleted — id: ${id}`)
}

export async function sendBranchTestSms(id: string, phone: string): Promise<SmsSentResponse> {
  const { data } = await adminApiClient.post<SmsSentResponse>(`/branches/${id}/sms-config/test`, { phone })
  console.log(`[INFO] Branch test SMS sent — id: ${id}, messageSid: ${data.messageSid}`)
  return data
}
